import React, { Component } from "react";
import CssClasses from "./Preferences.css";

import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import { ResetPaperLength } from "../../../Communication/AdminServicesHandler";
import NumericKeyboard, {
  ADJUSTED_FOR_ADMIN_RESET_ROLL_LENGTH
} from "../../../Components/Keyboards/NumericKeyboard/NumericKeyboard";

class Preferences extends Component {
  tabBtns = [
    { id: 1, title: "OPĆENITO" },
    { id: 2, title: "NOVČANICE" },
    { id: 3, title: "PAPIR" }
  ];

  state = {
    currentTab: 1,
    newPaperLengthM: -1,
    showsNumbericKeyboard: false,
    currentTextBoxID: 0
  };

  K_TEXTBOX_NEW_ROLL_LENGTH = 1;

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.contentBox}>
          <div className={CssClasses.tabButtons}>
            {this.tabBtns.map(btn => {
              return (
                <button
                  className={[
                    CssClasses.tabBtn,
                    this.state.currentTab === btn.id ? CssClasses.activeBtn : ""
                  ].join(" ")}
                  onClick={() => this.btnChangeTab_Click(btn.id)}
                  key={btn.id}
                >
                  {btn.title}
                </button>
              );
            })}
          </div>
          <div className={CssClasses.tabContent}>{this.getTabContent()}</div>
        </div>

        {this.state.showsNumbericKeyboard ? (
          <NumericKeyboard
            closeHandler={() => {
              this.onCloseNumericKeyboard();
            }}
            keyDownHandler={(value, isQuickPick) => {
              this.numericKeyboard_KeyDown(value, isQuickPick);
            }}
            customClass={ADJUSTED_FOR_ADMIN_RESET_ROLL_LENGTH}
          />
        ) : null}
      </div>
    );
  }

  getTabContent() {
    if (this.state.currentTab === 1) {
      //opcenito
      return (
        <div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>Oznaka terminala:</div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.TerminalLabel}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>Adresa terminala:</div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={[CssClasses.txtBox, CssClasses.fullWidth].join(" ")}
                value={this.props.machineInfo.Address}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>Minimalni saldo terminala:</div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.MinimumBalanceCents * 0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalna isplata po tiketu:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.MaximumPayoutCents * 0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalna uplata po tiketu:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.MaxBetAmountCents * 0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Minimalna uplata po tiketu:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.MinBetAmountCents * 0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksmimalan broj parova na tiketu:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.MaxPairs}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalan dobitak po tiketu:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.MaxWinAmountCents * 0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          {/* <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>&nbsp;</div>
            <div className={CssClasses.rightCol}>
              <button
                className={CssClasses.btnSave}
                onClick={() => this.btnSaveGeneral()}
              >
                SPREMI
              </button>
            </div>
            <div className={CssClasses.clearFix} />
          </div> */}
        </div>
      );
    } else if (this.state.currentTab === 2) {
      //opcenito
      return (
        <div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalno novčanica od 10BAM:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.MaximumBills10}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalno novčanica od 20BAM:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.MaximumBills20}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalno novčanica od 50BAM:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.MaximumBills50}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalno novčanica od 100BAM:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.MaximumBills100}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Maksimalno novčanica od 200BAM:
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={this.props.machineInfo.MaximumBills200}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          {/* <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>&nbsp;</div>
            <div className={CssClasses.rightCol}>
              <button
                className={CssClasses.btnSave}
                onClick={() => this.btnSaveBills()}
              >
                SPREMI
              </button>
            </div>
            <div className={CssClasses.clearFix} />
          </div> */}
        </div>
      );
    } else if (this.state.currentTab === 3) {
      //opcenito
      return (
        <div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>
              Minimalna dužina papira (metara):
            </div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.MinPaperLengthMM *
                  0.1 *
                  0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>Preostalo papira (metara):</div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(
                  this.props.machineInfo.CurrentPaperLengthMM *
                  0.1 *
                  0.01
                ).toFixed(2)}
                readOnly
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>Dužina nove role (metara):</div>
            <div className={CssClasses.rightCol}>
              <input
                type="text"
                className={CssClasses.txtBox}
                value={(this.state.newPaperLengthM >= 0
                  ? this.state.newPaperLengthM
                  : this.props.machineInfo.DefaultPaperLengthMM * 0.1 * 0.01
                ).toFixed(2)}
                onClick={() => {
                  this.txtNumeric_Enter(this.K_TEXTBOX_NEW_ROLL_LENGTH);
                }}
              />
            </div>
            <div className={CssClasses.clearFix} />
          </div>
          <div className={CssClasses.row}>
            <div className={CssClasses.leftCol}>&nbsp;</div>
            <div className={CssClasses.rightCol}>
              <button
                className={CssClasses.btnSave}
                onClick={() => this.btnResetPaper_Click()}
              >
                RESETIRAJ BROJAČ
              </button>
            </div>
            <div className={CssClasses.clearFix} />
          </div>
        </div>
      );
    }

    return null;
  }

  btnChangeTab_Click(id) {
    this.setState({ currentTab: id });
  }

  txtNumeric_Enter = id => {
    console.log(id);
    this.setState({
      showsNumbericKeyboard: true,
      currentTextboxID: id,
      newPaperLengthM: 0
    });
  };

  onCloseNumericKeyboard = () => {
    this.setState({ showsNumbericKeyboard: false });
  };

  numericKeyboard_KeyDown = (value, isQuickPick) => {
    console.log("VALUE ", value);

    if (value === -1) {
      //decimala, ne hendlamo to
      return;
    }

    if (value === -2) {
      //delete
      this.setState({ newPaperLengthM: 0 });
      return;
    }

    //popuni value
    var val = this.state.newPaperLengthM * 10 + value;
    this.setState({ newPaperLengthM: parseInt(val, 10) });
  };

  btnSaveGeneral() {}

  btnSaveBills() {}

  btnResetPaper_Click() {
    //loading
    this.props.changeAdminLoadingIndicator(true);

    //i zovi servis
    ResetPaperLength(
      this.props.machineInfo.MachineGUID,
      this.state.newPaperLengthM >= 0
        ? this.state.newPaperLengthM * 100 * 10
        : this.props.machineInfo.DefaultPaperLengthMM,
      this.resetPaperLength_Callback.bind(this)
    );
  }

  resetPaperLength_Callback = val => {
    this.props.changeAdminLoadingIndicator(false);

    if (val === 200) {
      this.props.setNewRollLength(this.state.newPaperLengthM * 100 * 10);
      this.props.setPopupMessage("Brojač papira je uspješno resetiran!");

      //podesi i u browseru
      window.cefCustomObject.resetCurrentPaperLength(
        this.state.newPaperLengthM * 100 * 10
      );
    } else {
      this.props.setPopupMessage(
        "Greška prilikom pozivanja servisa! Oznaka greške: " + val
      );
    }

    this.setState({ currentTextBoxID: 0, showsNumbericKeyboard: false });
  };
}

const mapStateToProps = state => {
  return {
    isAdminLoadingShown: state.rrNavigation.isAdminLoadingShown,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading)),
    setNewRollLength: newLengthMM =>
      dispatch(StoreActions.SetNewRollLength(newLengthMM))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preferences);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/Preferences/Preferences.js